import type { PatientContactDetailsWithAlternativeAddress } from '@common/validation/customControls/patientContactDetailsSchema';

export const addressInitialData = {
    city: null,
    houseLetter: null,
    houseNumber: null,
    houseNumberSuffix: null,
    street: null,
    zip: null,
};

export const patientContactDetailsWithAlternativeAddressInitialData: PatientContactDetailsWithAlternativeAddress = {
    ...addressInitialData,
    alternativeAddress: {
        city: null,
        houseLetter: null,
        houseNumber: null,
        houseNumberSuffix: null,
        street: null,
        zip: null,
    },
    emailAddress: null,
    homePhoneNumber: null,
    mobileNumber: null,
    sendToAlternativeAddress: false,
};
